export default __webpack_public_path__ + "static/media/workang.4266510a.jpeg";